export const BILL_STATES = ["All", "To Bill", "Unassigned", "Completed"];
export const TAGS = ["All", "CC", "UC", "APTM", "LACC", "LM", "ST"];
export const REGION_TIME_ZONES = ["All", "EDT", "CDT", "MDT", "PDT"];

export const mockBillers = [
  { id: 1, name: "Sharon Bryan", timezone: "Pacific Time" },
  { id: 2, name: "Facility Tone", timezone: "Pacific Time" },
  { id: 3, name: "Erin Wright", timezone: "Eastern Time" },
  { id: 4, name: "Amber Nichols", timezone: "Central Time" },
  { id: 5, name: "Avni Arora", timezone: "Mountain Time" },
];

export const mockBills = [
  {
    id: 1,
    proNumber: "PRO-984238",
    shipmentTag: "CC",
    billState: "To Bill",
    puNumber: "BL-2026RP91240",
    regionTimeZone: "EDT",
    originSic: "EWR",
    shipper: "ABC Logistics Inc",
    consignee: "-",
    weight: "500 lbs",
    timeInQueue: "4 hours",
    biller: "Sharon Bravo",
    serviceType: "LTL",
    status: "CC",
    scanningConfidence: 95,
    terminal: "MAVN - ATM",
    billToCode: "20266064 - GLB Solution",
    comments: "-",
  },
  {
    id: 2,
    proNumber: "PRO-875621",
    shipmentTag: "CC",
    billState: "To Bill",
    puNumber: "-",
    regionTimeZone: "EDT",
    originSic: "EWR",
    shipper: "Stellar Logistics",
    consignee: "-",
    weight: "500 lbs",
    timeInQueue: "4 hours",
    biller: "Sharon Bravo",
    serviceType: "Mexico",
    status: "CC",
    scanningConfidence: 95,
    terminal: "MAVN - ATM",
    billToCode: "21815345 - Adverto",
    comments: "-",
  },
  {
    id: 3,
    proNumber: "PRO-732945",
    shipmentTag: "UC",
    billState: "To Bill",
    puNumber: "BL-2026RP91240",
    regionTimeZone: "EDT",
    originSic: "EWR",
    shipper: "Summit Delivery Group",
    consignee: "-",
    weight: "500 lbs",
    timeInQueue: "4 hours",
    biller: "Sharon Bravo",
    serviceType: "LTL",
    status: "UC",
    scanningConfidence: 95,
    terminal: "MAVN - ATM",
    billToCode: "20266064 - GLB Solution",
    comments: "-",
  },
  {
    id: 4,
    proNumber: "PRO-691384",
    shipmentTag: "UC",
    billState: "To Bill",
    puNumber: "BL-2026RP91240",
    regionTimeZone: "EDT",
    originSic: "EWR",
    shipper: "Zephyr FreightWays",
    consignee: "-",
    weight: "500 lbs",
    timeInQueue: "4 hours",
    biller: "Sharon Bravo",
    serviceType: "Mexico",
    status: "UC",
    scanningConfidence: 95,
    terminal: "MAVN - ATM",
    billToCode: "21815345 - Adverto",
    comments: "-",
  },
  {
    id: 5,
    proNumber: "PRO-548927",
    shipmentTag: "CC",
    billState: "Unassigned",
    puNumber: "BL-2026RP91240",
    regionTimeZone: "EDT",
    originSic: "EWR",
    shipper: "Apex Global Shipping",
    consignee: "-",
    weight: "500 lbs",
    timeInQueue: "4 hours",
    biller: "-",
    serviceType: "LTL",
    status: "CC",
    scanningConfidence: 95,
    terminal: "MAVN - ATM",
    billToCode: "20266064 - GLB Solution",
    comments: "-",
  },
  {
    id: 6,
    proNumber: "PRO-423816",
    shipmentTag: "UC",
    billState: "Unassigned",
    puNumber: "-",
    regionTimeZone: "EDT",
    originSic: "EWR",
    shipper: "Nova Transport Solutions",
    consignee: "-",
    weight: "500 lbs",
    timeInQueue: "4 hours",
    biller: "-",
    serviceType: "Mexico",
    status: "UC",
    scanningConfidence: 95,
    terminal: "MAVN - ATM",
    billToCode: "21815345 - Adverto",
    comments: "-",
  },
  {
    id: 7,
    proNumber: "PRO-305742",
    shipmentTag: "UC",
    billState: "Unassigned",
    puNumber: "BL-2026RP91240",
    regionTimeZone: "EDT",
    originSic: "EWR",
    shipper: "Zenith Cargo Systems",
    consignee: "-",
    weight: "500 lbs",
    timeInQueue: "4 hours",
    biller: "-",
    serviceType: "LTL",
    status: "UC",
    scanningConfidence: 95,
    terminal: "MAVN - ATM",
    billToCode: "20266064 - GLB Solution",
    comments: "-",
  },
  {
    id: 8,
    proNumber: "PRO-267953",
    shipmentTag: "CC",
    billState: "Unassigned",
    puNumber: "BL-2026RP91240",
    regionTimeZone: "PDT",
    originSic: "LAX",
    shipper: "Horizon Freight Services",
    consignee: "-",
    weight: "500 lbs",
    timeInQueue: "4 hours",
    biller: "-",
    serviceType: "Mexico",
    status: "CC",
    scanningConfidence: 95,
    terminal: "MAVN - ATM",
    billToCode: "21815345 - Adverto",
    comments: "-",
  },
  {
    id: 9,
    proNumber: "PRO-192846",
    shipmentTag: "UC",
    billState: "Completed",
    puNumber: "BL-2026RP91240",
    regionTimeZone: "PDT",
    originSic: "LAX",
    shipper: "Vanguard Transit Corp",
    consignee: "Pinnacle Distribution LLC",
    weight: "500 lbs",
    timeInQueue: "4 hours",
    biller: "Sharon Bravo",
    serviceType: "LTL",
    status: "UC",
    scanningConfidence: 95,
    terminal: "MAVN - ATM",
    billToCode: "20266064 - GLB Solution",
    comments: "-",
  },
  {
    id: 10,
    proNumber: "PRO-156283",
    shipmentTag: "CC",
    billState: "Completed",
    puNumber: "BL-2026RP91240",
    regionTimeZone: "PDT",
    originSic: "LAX",
    shipper: "Pinnacle Distribution LLC",
    consignee: "Acme Manufacturing",
    weight: "500 lbs",
    timeInQueue: "4 hours",
    biller: "Sharon Bravo",
    serviceType: "Mexico",
    status: "CC",
    scanningConfidence: 95,
    terminal: "MAVN - ATM",
    billToCode: "21815345 - Adverto",
    comments: "-",
  },
];
